import { AmendBookingRequest } from '../interfaces';

export const getAmendBookingPageInitialProps = ({
  query,
}): AmendBookingRequest => {
  return {
    oldBooking: {
      bookingId: query.previousId,
      hotelSlug: query.hotelSlug,
    },
    newBooking: {
      bookingId: query.newId,
      hotelSlug: query.newHotelSlug,
    },
  };
};
